import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'lingui-react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import LoginPage from '../LoginPage';
import { redirectToLogout } from '../api';
import { isAuthorizedSelector } from '../redux/selectors';

import messages from './messages';

export function LogoutPage({ isAuthorized }) {
  if (isAuthorized) {
    // 1. dispatch the logout action
    // logout();
    // NOTE: It seems that a logout action is in fact not even necessary.
    // This is because the redirect to Portunus below will empty out our Redux store anyway.

    // 2. redirect to Portunus for the login page
    // The action of hitting that logout page will cause Portunus to log us out,
    // issuing a single-sign-out to other services.  It will then redirect to our
    // application, but since we're now logged out, this will trigger a redirect
    // to the Portunus login page will then
    redirectToLogout();

    return (
      <LoginPage>
        <p><Trans id={messages.loggingOut} /></p>
      </LoginPage>
    );
  }

  return (
    <Redirect to="/login" />
  );
}

LogoutPage.propTypes = {
  isAuthorized: PropTypes.bool.isRequired,
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isAuthorized: isAuthorizedSelector(state),
  };
}

export default connect(mapStateToProps)(LogoutPage);



// WEBPACK FOOTER //
// ./features/authentication/LogoutPage/index.js